import React from 'react'
import ReactDOM from 'react-dom'
import {
  from,
  HttpLink,
  ApolloLink,
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
} from '@apollo/client'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import { onError } from '@apollo/client/link/error';
import { Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'

import App from './App'

import { getCookie, hasCookie } from './utils/cookie'

import 'bulma/css/bulma.css'
import 'bulma-extensions/dist/css/bulma-extensions.min.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-notifications/lib/notifications.css'
import './index.css'

const browserHistory = createBrowserHistory()
const httpLink = new HttpLink({ uri: '/graphql' })

const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      authorization:
        (hasCookie('token') && `Bearer ${getCookie('token')}`) || null,
    },
  })
  return forward(operation)
})

const merchantMiddleware = new ApolloLink((operation, forward) => {
  if (operation.operationName !== 'Login') {
    operation.variables = {
      ...operation.variables,
      merchantId: getCookie('merchant'),
      // idProvider: getCookie('provider'),
    }
  }
  return forward(operation)
})

const handleError = onError(({ graphQLErrors, networkError }) => {
  if (networkError) {
    NotificationManager.error(networkError, 'Error', 2000)
  }
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message}) => NotificationManager.error(message, 'Error', 2000))
  }
})

const client = new ApolloClient({
  credentials: 'include',
  queryDeduplication: false,
  cache: new InMemoryCache(),
  link: from([handleError, authMiddleware, merchantMiddleware, httpLink]),
})

ReactDOM.render(
    <ApolloProvider client={client}>
        <Router history={browserHistory}>
          <App />
          <NotificationContainer/>
        </Router>
      </ApolloProvider>,
  document.getElementById('root'),
)
